import { pathExists } from '@wix/cli-fs';
import { CliErrorCode, CliError } from '@wix/cli-error';
import { readBuildManifest } from './build.config.js';

export async function assertBuildOutputExists(projectFolder: string) {
  const buildManifest = await readBuildManifest(projectFolder);

  const targets = [
    buildManifest.appManifestPath,
    buildManifest.outDir,
    buildManifest.clientDir,
    ...(buildManifest.serverDir ? [buildManifest.serverDir] : []),
  ];

  for (const target of targets) {
    if (!(await pathExists(target))) {
      throw new CliError({
        code: CliErrorCode.BuildOutputMissing({
          reason: `"${target}" build output file is missing.`,
        }),
        cause: null,
      });
    }
  }
}
